/**
 * Worker timesheet display helpers.
 *
 * `hours_half` хранится в полу-часах (см. backend §1.3 / `models/timesheet.py`) —
 * никакая логика расчёта capacity на API не уходит во float. UI же показывает
 * рабочему привычные часы, поэтому делим на 2 на самом краю.
 */

const HALF_PER_HOUR = 2;

/** "5.0 ч" / "0.5 ч" / "0 ч" — один формат на все экраны worker-flow. */
export function formatHoursHalf(hoursHalf: number, suffix: string = "ч"): string {
  if (hoursHalf <= 0) return `0 ${suffix}`;
  const whole = Math.floor(hoursHalf / HALF_PER_HOUR);
  const half = hoursHalf % HALF_PER_HOUR;
  // Всегда показываем один знак после точки — табличный вид, без «5» рядом с «4.5».
  return `${whole}.${half ? 5 : 0} ${suffix}`;
}

/** Компактные часы для подписей: целое без `.0`, половина с одним знаком. */
export function formatHoursHalfCompact(hoursHalf: number): string {
  const hours = hoursHalf / HALF_PER_HOUR;
  return `${Number.isInteger(hours) ? hours : hours.toFixed(1)} ч`;
}

/** Сумма live-entries в полу-часах. */
export function sumHoursHalf(items: ReadonlyArray<{ hours_half: number }>): number {
  let total = 0;
  for (const it of items) total += it.hours_half;
  return total;
}

/**
 * Компактный формат длительности для admin-audit (§20/3.1).
 *
 * < 1 ч: «X мин Y с» — мастеру важна точность на коротких отчётах (это и есть
 * целевая метрика, 30 сек норма).
 * ≥ 1 ч: «N ч M мин» — без секунд, всё равно шум при таких длительностях.
 * 0 / null / отрицательное: «0 с» (caller сам решает рендерить «—» вместо).
 */
export function formatHmsCompact(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds));
  if (total < 3600) {
    const mins = Math.floor(total / 60);
    const secs = total % 60;
    return `${mins} мин ${secs} с`;
  }
  const hours = Math.floor(total / 3600);
  const mins = Math.floor((total % 3600) / 60);
  return `${hours} ч ${mins} мин`;
}
